import React from "react";
import TextareaAutosize from "react-textarea-autosize";
import styles from "./Style.module.css";

const NotesInput = ({
  name,
  label,
  optionalText,
  subText,
  value = "",
  onChange,
  error = "",
  placeholder = "",
  maxLength,
  wrapperClassName = "",
  formGroupClassName = "",
  labelClassName = "",
  countClassName = "",
  inputClassName = "form-control",
  autoComplete = "off",
}) => {
  const characterCount = value.length;

  return (
    <div className={wrapperClassName}>
      <div className={formGroupClassName}>
        <label className={labelClassName}>
          {label} <span>{optionalText}</span>
          <span className={countClassName}>
            {" "}
            {characterCount}/{maxLength}
          </span>
        </label>
        <TextareaAutosize
          name={name}
          value={value}
          onChange={onChange}
          className={`${inputClassName} ${styles.notesInput}`}
          autoComplete={autoComplete}
          placeholder={placeholder}
        />
        {error ? <div className="error-msg">{error}</div> : null}
        {subText ? <p className={styles.subText}>{subText}</p> : null}
      </div>
    </div>
  );
};

export default NotesInput;
